import { IDropDownValues, IModuleData } from './types';

export const convertDataToDropdownList = (
  data: IModuleData[]
): IDropDownValues[] => {
  return data.map((item) => ({
    label: item.title,
    value: {
      newTab: item.newTab,
      url: item.url,
    },
  }));
};
